import { z } from 'zod/v4';

export const GetBulkCompanyProfilesParamsSchema = z.object({
  templateId: z.string().min(1),
});

export type GetBulkCompanyProfilesParams = z.infer<
  typeof GetBulkCompanyProfilesParamsSchema
>;

export const GetBulkCompanyProfilesQuerySchema = z.object({
  forCompanyIds: z.string().min(1),
});

export type GetBulkCompanyProfilesQuery = z.infer<
  typeof GetBulkCompanyProfilesQuerySchema
>;

// Loose: alongside `data`, each item carries a flat set of denormalized legacy
// columns (officialName, displayName, facilityProcesses as raw JSON text the FE
// parses itself, ...) — mirrors the legacy schema's `additionalProperties: true`.
export const BulkCompanyProfileItemSchema = z
  .object({
    forCompanyId: z.string(),
    byCompanyId: z.string(),
    onBehalfOfCompanyId: z.string(),
    profileType: z.string(),
    data: z.record(z.string(), z.unknown()),
  })
  .loose();

export type BulkCompanyProfileItem = z.infer<
  typeof BulkCompanyProfileItemSchema
>;

export const GetBulkCompanyProfilesResponseSchema = z.array(
  BulkCompanyProfileItemSchema,
);

export type GetBulkCompanyProfilesResponse = z.infer<
  typeof GetBulkCompanyProfilesResponseSchema
>;
